import { Join } from '@plato/ui/containers/join';
import type { ReactElement } from 'react';
import type { ActivityFeedVisitPayload } from '../../../server/types/customer-activity-feed-types.ts';
import type { TaskCompletedSource } from '../../analytics/types/analytics-events.ts';
import { orderVisitLogged } from '../lib/order-visit-logged.ts';
import { ActivityFeedNoteItem } from './activity-feed-note-item.tsx';
import { VisitLoggedItem } from './visit-logged-item.tsx';

type Props = {
    payload: ActivityFeedVisitPayload;
    source: TaskCompletedSource;
};

/**
 * A logged visit: its report as the regular note card, with what was logged on it glued
 * underneath as cards of their own — each linked quote with its tasks, the other tasks, then
 * the insight outcomes.
 */
export function ActivityFeedVisitItem({ payload, source }: Props): ReactElement {
    const { tasks, outcomes, quotes, ...note } = payload;

    return (
        <Join orientation="vertical">
            <ActivityFeedNoteItem note={note} />
            {orderVisitLogged(payload).map((entry) => (
                <VisitLoggedItem key={entry.key} entry={entry} source={source} />
            ))}
        </Join>
    );
}
